__turbopack_context__.v({
  "callout-title": "dbo8hW_callout-title",
  "chapter-body": "dbo8hW_chapter-body",
  "chapter-copy": "dbo8hW_chapter-copy",
  "globe": "dbo8hW_globe",
  "globe-wrap": "dbo8hW_globe-wrap",
  "hero-video": "dbo8hW_hero-video",
  "hero-video--under-header": "dbo8hW_hero-video--under-header",
  "map-image": "dbo8hW_map-image",
  "type-action": "dbo8hW_type-action",
  "type-action-button": "dbo8hW_type-action-button",
  "type-body": "dbo8hW_type-body",
  "type-card": "dbo8hW_type-card",
  "type-card--globe": "dbo8hW_type-card--globe",
  "type-link": "dbo8hW_type-link",
  "type-title": "dbo8hW_type-title",
});
